import { Box } from "@mui/material";
import type { ComponentType } from "react";

type RiveContainerProps = {
  RiveComponent: ComponentType;
  /** Lado del cuadrado del canvas (por defecto 360) */
  boxSize?: number;
};

export const RiveContainer = ({ RiveComponent, boxSize = 260 }: RiveContainerProps) => {
  return (
    <>
      <Box
        sx={{
          width: boxSize,
          height: boxSize,
          overflow: "visible",
          margin: "0 0",
          mt: -4,
        }}
      >
        <Box sx={{ width: "100%", height: "100%" }}>
          <RiveComponent />
        </Box>
      </Box>
    </>
  );
};
